import { mergeTablePaginationParams } from '@/utils'

import { customInstance } from '../auth/axios-config'

import {
  CreateReportingEventRequest,
  ReportingEvent,
  ReportingEventListParams,
  UpdateReportingEventRequest,
} from './types'

const API_ENDPOINT_REPORTING_EVENTS = '/admin/v1/reporting-events'

export interface ReportingEventListResponse {
  success: boolean
  data: ReportingEvent[]
  metadata?: {
    total: number
    limit: number
    offset: number
    returned: number
  }
}

export interface ReportingEventDetailResponse {
  success: boolean
  data: ReportingEvent[]
}

export interface CreateReportingEventResponse {
  success: boolean
  data: ReportingEvent[]
  metadata: Record<string, unknown>
}

export interface UpdateReportingEventResponse {
  success: boolean
  data: ReportingEvent
  metadata: Record<string, unknown>
}

export interface DeleteReportingEventResponse {
  success: boolean
  data: boolean
  metadata: Record<string, unknown>
}

export const reportingEventApi = {
  getReportingEventList: async (
    params?: ReportingEventListParams
  ): Promise<ReportingEventListResponse> => {
    const url = `${API_ENDPOINT_REPORTING_EVENTS}/list`

    const requestParams: Partial<import('@/schema').RequestFilters> = {
      offset: params?.offset,
      q: params?.q,
      sort_by: params?.sort_by,
      filter_by: params?.filter_by,
    }

    if (params?.limit !== undefined) {
      requestParams.limit = params.limit
    }

    const requestBody = mergeTablePaginationParams(requestParams)

    if (params?.limit === undefined && params?.q) {
      delete requestBody.limit
    }

    const response = await customInstance<ReportingEventListResponse>({
      url,
      method: 'POST',
      data: requestBody,
    })

    return response
  },

  getReportingEventById: async (
    id: string
  ): Promise<ReportingEventDetailResponse> => {
    const url = `${API_ENDPOINT_REPORTING_EVENTS}/${id}`

    const response = await customInstance<ReportingEventDetailResponse>({
      url,
      method: 'GET',
    })

    return response
  },

  createReportingEvent: async (
    data: CreateReportingEventRequest
  ): Promise<CreateReportingEventResponse> => {
    const url = `${API_ENDPOINT_REPORTING_EVENTS}`

    const response = await customInstance<CreateReportingEventResponse>({
      url,
      method: 'POST',
      data,
    })

    return response
  },

  updateReportingEvent: async (
    id: string,
    data: UpdateReportingEventRequest
  ): Promise<UpdateReportingEventResponse> => {
    const url = `${API_ENDPOINT_REPORTING_EVENTS}/${id}`

    const response = await customInstance<UpdateReportingEventResponse>({
      url,
      method: 'PUT',
      data,
    })

    return response
  },

  deleteReportingEvent: async (
    id: string
  ): Promise<DeleteReportingEventResponse> => {
    const url = `${API_ENDPOINT_REPORTING_EVENTS}/${id}`

    const response = await customInstance<DeleteReportingEventResponse>({
      url,
      method: 'DELETE',
    })

    return response
  },
}
